/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetGipAltReportEvidenceExportUrl1QueryResponse, GetGipAltReportEvidenceExportUrl1PathParams, GetGipAltReportEvidenceExportUrl1404 } from "../models/GetGipAltReportEvidenceExportUrl1";

export function getGetGipAltReportEvidenceExportUrl1Url(id: GetGipAltReportEvidenceExportUrl1PathParams["id"]) {
  const res = { method: 'GET', url: `/reports/gip-alt/report/${id}/export-url` as const }
  return res
}

/**
 * @summary Get export URL for existing report
 * {@link /reports/gip-alt/report/:id/export-url}
 */
export async function getGipAltReportEvidenceExportUrl1(id: GetGipAltReportEvidenceExportUrl1PathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetGipAltReportEvidenceExportUrl1QueryResponse, ResponseErrorConfig<GetGipAltReportEvidenceExportUrl1404>, unknown>({ method : "GET", url : getGetGipAltReportEvidenceExportUrl1Url(id).url.toString(), ... requestConfig })
  return res.data
}